// extracted by mini-css-extract-plugin
export var calendarView = "_or-0";